export const VisitLabel = 'visit';
export const NotesLabel = 'notes';
export const SheetLabel = 'sheet';
export const TasksLabel = 'tasks';
export const CommsLabel = 'comms';
export const AuditLabel = 'audit';

export type SegmentLabelType = typeof VisitLabel | typeof NotesLabel | typeof SheetLabel | typeof TasksLabel | typeof CommsLabel | typeof AuditLabel;

export enum SelectedPatientSegmentPanel {
	None,
	Visit,
	Notes,
	Sheet,
	Tasks,
	Comms,
	Audit
}

export enum CommsPanelChildType {
	None,
	CommunicationsLog,
	ReferringVet,
	OwnerInformation
}